import { page, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  fullscreen: [{ path: "welcome", lazy: page(() => import("./WelcomePage")) }],
};
